var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_vm._m(0),_c('div',{staticClass:"f v fvc"},[_c('div',{staticClass:"back-btn",on:{"click":_vm.backHome}},[_vm._v("返回首页")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box f v fvc"},[_c('img',{staticClass:"status-img",attrs:{"src":"https://j.weizan.cn/youxiang/check-failed.png"}}),_c('div',{staticClass:"tip"},[_vm._v("二维码已失效")])])
}]

export { render, staticRenderFns }